<!--人员报名-->
<template>
  <div class="add-ry-info-container">
    <div>
      <van-nav-bar
        class="custom-nav-bar"
        title="信息填写"
        left-text="返回"
        left-arrow
        @click-left="onTopClickLeft"
      >
        <a
          :href="
            routeValue === null ||
            routeValue === undefined ||
            routeValue.length === 0
              ? 'https://www.ptty.com.cn/wap/#/'
              : 'https://www.ptty.com.cn/wap/#/' + routeValue
          "
          slot="right"
          class="home-icon-link"
        >
          <van-icon class="home-icon" name="wap-home" />
        </a>
      </van-nav-bar>
    </div>
    <div class="content-wrapper">
      <div class="event-title-card">
        {{ resultXmData.SSMC }}
      </div>
      <van-cell
        v-if="bmLx === 'GR'"
        class="project-cell"
        title="项目"
        :value="
          resultXmData.XMJC +
            '(' +
            (resultXmData.SSLX === 'MS' ||
            resultXmData.SSLX === 'WS' ||
            resultXmData.SSLX === 'XS'
              ? resultXmData.ISXB === 'Y'
                ? resultXmData.SSLXMC
                : '单打'
              : resultXmData.ISXB === 'Y'
              ? resultXmData.SSLXMC
              : resultXmData.SSLXMC) +
            ')'
        "
      />
      <van-row v-if="bmLx === 'GR'" class="info-banner">
        <div class="info-banner-content">
          <div class="info-banner-left">
            <label class="info-label">
              <van-icon name="comment" class="comment-icon" />
              <span>请填写队伍或俱乐部名称</span>
            </label>
          </div>
          <div class="info-banner-right">
            <label class="required-label">
              <span class="required-star">*</span>号为必填
            </label>
          </div>
        </div>
      </van-row>

      <!-- 队伍信息卡片 -->
      <div
        class="team-info-card"
        v-if="bmLx === 'GR' || ryInfo.LDTEL.VALUE.length > 0"
      >
        <div class="card-header">
          <van-icon name="friends-o" class="header-icon" />
          <span class="header-title">队伍信息</span>
        </div>

        <!-- 队伍全称 - 可编辑 -->
        <van-field
          v-if="
            ISUPTDWMC !== 'N' &&
              bmLx === 'GR' &&
              ryInfo.LDTEL.VALUE.length === 0
          "
          v-model="ryInfo.DWQC.VALUE"
          class="custom-field"
          label="队伍全称"
          placeholder="请输入队伍全称"
          @blur="handleDwqcBlur"
        >
          <template #button v-if="SSISBM === 'Y'">
            <van-button
              class="select-team-btn"
              size="small"
              type="info"
              @click="openModal()"
            >
              选择队伍
            </van-button>
          </template>
        </van-field>

        <!-- 队伍全称 - 禁用状态改为文本显示 -->
        <div
          v-if="
            (ISUPTDWMC !== 'N' &&
              (bmLx !== 'GR' || ryInfo.LDTEL.VALUE.length > 0)) ||
              ISUPTDWMC === 'N'
          "
          class="info-text-row"
        >
          <span class="info-label">队伍全称</span>
          <span class="info-value">{{ ryInfo.DWQC.VALUE || "-" }}</span>
        </div>

        <!-- 队伍简称 - 文本显示 -->
        <div v-if="ryInfo.LDTEL.VALUE.length > 0" class="info-text-row">
          <span class="info-label">队伍简称</span>
          <span class="info-value">{{ ryInfo.DWJC.VALUE || "-" }}</span>
        </div>

        <!-- 领队信息 - 文本显示 -->
        <div
          v-if="ryInfo.LDXM.VALUE.length > 0 && bmLx !== 'GR'"
          class="info-text-row"
        >
          <span class="info-label">领队姓名</span>
          <span class="info-value">{{ ryInfo.LDXM.VALUE }}</span>
        </div>
        <div
          v-if="ryInfo.LDTEL.VALUE.length > 0 && bmLx !== 'GR'"
          class="info-text-row"
        >
          <span class="info-label">领队电话</span>
          <span class="info-value">{{ ryInfo.LDTEL.VALUE }}</span>
        </div>
      </div>

      <!-- 原有的字段保留（用于非队伍信息卡片情况） -->
      <van-field
        v-if="
          ISUPTDWMC !== 'N' && !(bmLx === 'GR' || ryInfo.LDTEL.VALUE.length > 0)
        "
        v-model="ryInfo.DWQC.VALUE"
        :disabled="bmLx !== 'GR' || ryInfo.LDTEL.VALUE.length > 0"
        class="custom-field"
        label="队伍全称"
        placeholder="请输入队伍全称"
      >
        <template
          #button
          v-if="
            bmLx === 'GR' && ryInfo.LDTEL.VALUE.length === 0 && SSISBM === 'Y'
          "
        >
          <van-button
            v-if="ISUPTDWMC !== 'N'"
            class="select-team-btn"
            size="small"
            type="info"
            @click="openModal()"
            >选择队伍</van-button
          >
        </template>
      </van-field>
      <van-field
        v-if="
          ISUPTDWMC === 'N' && !(bmLx === 'GR' || ryInfo.LDTEL.VALUE.length > 0)
        "
        v-model="ryInfo.DWQC.VALUE"
        :disabled="true"
        class="custom-field"
        label="队伍全称"
        placeholder="请输入队伍全称"
      >
        <template
          #button
          v-if="bmLx === 'GR' && ryInfo.LDTEL.VALUE.length === 0"
        >
        </template>
      </van-field>
      <van-field
        v-model="ryInfo.DWJC.VALUE"
        v-if="
          ryInfo.LDTEL.VALUE.length > 0 &&
            !(bmLx === 'GR' || ryInfo.LDTEL.VALUE.length > 0)
        "
        disabled
        class="custom-field"
        label="队伍简称"
        placeholder="请输入队伍简称"
      />
      <van-field
        v-if="
          ryInfo.LDXM.VALUE.length > 0 &&
            bmLx !== 'GR' &&
            !(bmLx === 'GR' || ryInfo.LDTEL.VALUE.length > 0)
        "
        v-model="ryInfo.LDXM.VALUE"
        disabled
        class="custom-field"
        label="领队姓名"
      />
      <van-field
        v-if="
          ryInfo.LDTEL.VALUE.length > 0 &&
            bmLx !== 'GR' &&
            !(bmLx === 'GR' || ryInfo.LDTEL.VALUE.length > 0)
        "
        v-model="ryInfo.LDTEL.VALUE"
        disabled
        class="custom-field"
        label="赛事负责人手机号"
      />
      <van-cell
        v-if="resultXmData.ISSF === '1'"
        class="fee-cell"
        title="报名费"
        :value="resultXmData.SFJE === 0 ? '多标准' : resultXmData.SFJE + '元'"
      />
      <van-cell
        v-if="resultXmData.ISHYMF === '1'"
        class="member-discount-cell"
        title="会员是否优惠"
        :value="'是'"
      />
    </div>
    <report-ry-info-com
      v-if="isYesBmShow"
      :resultXmData="resultXmData"
      :ryInfo="ryInfo"
      :SSLXTYPE="SSLXTYPE"
      :lxrDataList="lxrDataList"
      :utilPost="utilPost"
      :setValueFn="setBtnDis"
      :ssid="ssid"
      :XBTYPE="XBTYPE"
      :SSLX="SSLX"
      :XMID="xmid"
    ></report-ry-info-com>
    <!--底部按钮  开始-->
    <van-tabbar
      v-if="isShow && SSISBM === 'Y' && isYesBmShow"
      class="custom-tabbar"
    >
      <van-goods-action class="custom-goods-action">
        <van-goods-action-button
          v-if="YesCsqrsVal.length > 0"
          class="view-confirm-btn"
          type="info"
          text="查看参赛确认书"
          @click="openSignModelYes"
        />
        <van-goods-action-button
          class="submit-btn"
          type="primary"
          :disabled="tjBtnDis"
          :text="czlx === 'ADD' ? '提交报名' : '确认修改'"
          @click="sumbitData"
        />
      </van-goods-action>
    </van-tabbar>
    <!--底部按钮  结束-->
    <div class="bottom-spacer"></div>
    <loading-com></loading-com>
    <!-- 支付组件  开始 -->
    <enter-pay-com ref="paymodal"></enter-pay-com>
    <!-- 支付组件  结束 -->

    <!-- 签署参赛确认书 开始 -->
    <van-action-sheet
      v-model="isCsqrsTabVisible"
      title="签署参赛确认书"
      class="confirm-sheet"
    >
      <div class="confirm-content">
        <div v-html="CSQRSHTML + singImgBase64" class="confirm-html"></div>
        <van-goods-action class="confirm-actions">
          <van-goods-action-button
            class="cancel-btn"
            type="danger"
            text="取消"
            @click="isCsqrsTabVisible = false"
          />
          <van-goods-action-button
            class="sign-btn"
            type="info"
            :text="isSign ? '重新签名' : '签署参赛确认书'"
            @click="openSignModel"
          />
          <van-goods-action-button
            v-if="isSign"
            class="confirm-register-btn"
            type="primary"
            :text="czlx === 'ADD' ? '确认报名' : '确认修改'"
            @click="sendServerBmInfo"
          />
        </van-goods-action>
      </div>
    </van-action-sheet>
    <!-- 签署参赛确认书 结束 -->
    <!-- 查看参赛确认书 开始 -->
    <van-action-sheet
      v-model="yesCsqrsVisible"
      title="参赛确认书"
      class="view-confirm-sheet"
    >
      <div class="view-confirm-content">
        <div v-html="YesCsqrsVal" class="view-confirm-html"></div>
      </div>
    </van-action-sheet>
    <!-- 查看参赛确认书 结束 -->
    <!-- 在线签字 开始 -->
    <signature-pad
      :cancel="cancel"
      :confirm="confirm"
      v-if="signVisible"
    ></signature-pad>
    <!-- 在线签字 结束 -->

    <!-- 选取联系人弹出框 开始-->
    <van-action-sheet
      v-model="selectDwVisible"
      :title="
        isDwXiangJin === '0' ? '请选择队伍名称' : '通过AI识别存在相近队伍名称'
      "
      :class="[
        isDwXiangJin === '0' ? 'select-team-sheet' : 'select-team-sheet-jg'
      ]"
    >
      <div class="select-team-content">
        <div class="select-team-notice" v-if="isDwXiangJin === '0'">
          注意：如果列表没有您要选择的队伍名称，可直接输入名称进行报名
        </div>
        <div class="select-team-notice" v-if="isDwXiangJin === '1'">
          通过AI数据模型检测，您输入的队伍名称和下方队伍名称相近，请确认是否为同一队伍。
          <div style="font-size:17px;font-weight: 600;">
            请您仔细核对，避免抽签出现同组重复！！！
          </div>
          如果下方没有您的队伍名称，可关闭弹窗，继续填写信息。
        </div>
        <div class="searchDwInfoDiv" v-if="isDwXiangJin === '0'">
          <van-field
            v-model="info"
            left-icon="search"
            center
            clearable
            label=""
            class="search-field"
            placeholder="请输入队伍信息"
          >
            <template #button>
              <van-button
                class="search-btn"
                size="small"
                type="primary"
                @click="getDwList"
                >检索</van-button
              >
            </template>
          </van-field>
        </div>
        <van-cell
          v-for="(item, index) in dwList"
          :key="index"
          class="team-item"
          :title="item.DWQC"
          :value="item.DWQC"
          is-link
          @click="selectItemConnect(item)"
        />
        <div class="select-team-spacer"></div>
      </div>
    </van-action-sheet>
    <!-- 选取联系人弹出框 结束-->

    <!-- 报名结束确认框 开始 -->
    <van-action-sheet v-model="confirmVisible" title="请选择操作类型">
      <div class="payment-action-content">
        <!-- 成功提示 -->
        <div class="success-notice">
          <van-icon name="checked" class="success-icon" />
          <div class="notice-text">
            <div class="notice-title">您已报名成功</div>
            <div class="notice-desc" v-if="resultXmData.ISSF === '1'">
              请3小时内及时完成支付，否则报名信息将被自动删除
            </div>
            <div class="notice-warning" v-if="resultXmData.ISSF === '1'">
              <van-icon name="warning-o" class="warning-icon" />
              您可以进入我的项目菜单中，完成支付
            </div>
          </div>
        </div>

        <!-- 操作按钮组 -->
        <div class="payment-buttons-wrapper">
          <button class="modern-btn later-btn" @click="handleContinue">
            <div class="btn-content">
              <van-icon name="clock-o" class="btn-icon" />
              <span class="btn-text">{{
                this.payJumpModal.ISSF === "1"
                  ? "继续添加，稍后支付"
                  : "继续添加"
              }}</span>
            </div>
          </button>
          <button class="modern-btn payment-btn" @click="handlePayment">
            <div class="btn-content">
              <van-icon name="gold-coin-o" class="btn-icon" />
              <span class="btn-text">{{
                this.payJumpModal.ISSF === "1" ? "立即支付" : "查看信息"
              }}</span>
            </div>
          </button>
        </div>
      </div>
    </van-action-sheet>
    <!-- 报名结束确认框 结束 -->
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";
import ReportRyInfoCom from "../commonCom/ReportRyInfoCom.vue";
import EnterPayCom from "../commonCom/EnterPayCom.vue";
import { Dialog } from "vant";
import SignaturePad from "../commonCom/SignaturePad.vue";
export default {
  components: { ReportRyInfoCom, LoadingCom, EnterPayCom, SignaturePad },
  name: "AddRyInfo",
  data() {
    return {
      confirmVisible: false,
      isPay: false,
      BSLXRTEL: "",
      BSLXR: "",
      tjBtnTxt: "提交",
      tjBtnDis: false,
      bmLx: "", //报名类型 GR：个人报名  TEAM：领队报名
      isShow: false,
      utilPost: "",
      ssid: "",
      op: "wapGL",
      xmid: "",
      resultXmData: {},
      SSLXTYPE: "",
      XBTYPE: "",
      SSLX: "",
      sslxXb: "", //赛事类型的性别
      lxrDataList: [], //联系人数组
      czlx: "",
      ryInfo: {
        ISKZ: {
          VALUE: "0",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        DWID: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        DWJC: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        DWQC: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        LDXM: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        }, //领队姓名
        LDTEL: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        }, //赛事负责人手机号
        JLXM: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        }, //教练姓名
        JLTEL: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        }, //教练手机号
        DYXM: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        }, //队医姓名
        DYTEL: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        }, //对医手机号
        QTRYXM: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        }, //其他人员姓名
        QTRYTEL: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        }, //其他随队人员手机号

        RYID1: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        RYXM1: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        XB1: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        TEL1: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        ZJLX1: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        SFZH1: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        SR1: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "0",
          MBVAL: ""
        },
        DTKJLIST1: [],
        MGZIMG1: {
          VALUE: [],
          ISBT: "",
          ISSHOW: "0",
          MBVAL: "" //模版默认值
        }, //免冠照

        RYID2: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        RYXM2: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        XB2: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        TEL2: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        ZJLX2: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        SFZH2: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        MGZIMG2: {
          VALUE: [],
          ISBT: "",
          ISSHOW: "0",
          MBVAL: "" //模版默认值
        }, //免冠照
        SR2: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "0",
          MBVAL: ""
        },
        DTKJLIST2: [],

        RYID3: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        RYXM3: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        XB3: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        TEL3: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        ZJLX3: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        SFZH3: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "1",
          MBVAL: ""
        },
        MGZIMG3: {
          VALUE: [],
          ISBT: "",
          ISSHOW: "0",
          MBVAL: "" //模版默认值
        }, //免冠照
        SR3: {
          VALUE: "",
          ISBT: "",
          ISSHOW: "0",
          MBVAL: ""
        },
        DTKJLIST3: []
      },
      isCyWrite: "0",
      isTeamSelect: "0",
      SSISBM: "N",
      CSQRSHTML: "",
      isCsqrsTabVisible: false,
      signVisible: false,
      singImgBase64: "",
      isSign: false,
      uis: {},
      YesCsqrsVal: "",
      yesCsqrsVisible: false,
      routeValue: "",
      dwList: [],
      info: "",
      selectDwVisible: false,
      yhddh: "",
      checkBmrsLx: "",
      isYesBmShow: true,
      ISUPTDWMC: "Y",
      payJumpModal: {
        XMNM: "",
        XMID: "",
        ISSF: ""
      },
      isDwXiangJin: "0"
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
    this.xmid = this.$route.query.xmid;

    this.yhddh = this.$route.query.yhddh;
    this.ryInfo.DWID.VALUE = this.$route.query.dwid;
    this.bmLx = this.$route.query.bmLx;
    this.czlx = this.$route.query.czlx;
    var checkBmrsLx = this.$route.query.checkBmrsLx;
    if (checkBmrsLx !== undefined && checkBmrsLx !== null) {
      this.checkBmrsLx = checkBmrsLx;
    }
    this.isTeamSelect = this.$route.query.isTeamSelect;
    if (
      this.isTeamSelect === undefined ||
      this.isTeamSelect === null ||
      this.isTeamSelect === ""
    ) {
      this.isTeamSelect = "0";
    }
    var isCyWriteParam = this.$route.query.isCyWrite;
    if (isCyWriteParam === undefined || isCyWriteParam.length === 0) {
    } else {
      this.isCyWrite = isCyWriteParam;
    }
    if (this.czlx === "UPT") {
      var ryid1Param = this.$route.query.ryid1Param;
      var ryid2Param = this.$route.query.ryid2Param;
      var ryid3Param = this.$route.query.ryid3Param;
      if (ryid1Param === undefined || ryid1Param.length === 0) {
      } else {
        this.ryInfo.RYID1.VALUE = ryid1Param;
      }
      if (ryid2Param === undefined || ryid2Param.length === 0) {
      } else {
        this.ryInfo.RYID2.VALUE = ryid2Param;
      }
      if (ryid3Param === undefined || ryid3Param.length === 0) {
      } else {
        this.ryInfo.RYID3.VALUE = ryid3Param;
      }
    }
  },
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    var openIdEn = localStorage.getItem("openIdEn");
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      this.utilPost.getOpenId(function(openId) {
        this.$router.push({ path: "/loginIndex" });
      });
    } else {
      var ryInfoLogin = this.utilPost.getLogin();
      if (!ryInfoLogin.isLogin) {
        this.$router.push({ path: "/loginIndex" });
      }
    }
    var that = this;
    this.utilPost.getOpenId(function(openId) {
      var ryInfo = that.utilPost.getLogin();
      that.uis = ryInfo;
      // alert(JSON.stringify(that.ryInfo));
    });
    this.mainData();
    this.getIsBmLoad();
  },
  methods: {
    handleDwqcBlur() {
      if (this.ryInfo.DWQC.VALUE && this.ryInfo.DWQC.VALUE.length > 0) {
        var busData = {
          DWQC: this.ryInfo.DWQC.VALUE
        };
        var paramData = {
          headerData: {
            ssid: this.ssid,
            op: this.op, //反射名称
            methodName: "wapCheckDwqc" //对应的方法名
          },
          busData: busData //参数内容
        };
        this.utilPost.paramData = paramData;
        //alert(JSON.stringify(paramData));
        this.utilPost.sendPost().then(data => {
          if (data.isSuccess) {
            this.isDwXiangJin = "1";
            this.dwList = data.content;
            this.selectDwVisible = true;
          }
        });
      }
    },
    openModal() {
      this.getDwList();
    },
    getDwList() {
      this.isDwXiangJin = "0";
      var busData = {
        info: this.info
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getDwInfo" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.dwList = data.content;
        this.selectDwVisible = true;
        this.isDwXiangJin = "0";
      });
    },
    selectItemConnect(item) {
      this.ryInfo.DWQC.VALUE = item.DWQC;
      this.selectDwVisible = false;
    },
    getIsBmLoad() {
      var busData = {};
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "checkIsBm" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.SSISBM = data.content;

        if (this.SSISBM !== "Y") {
          this.$notify({
            type: this.czlx !== "UPT" ? "danger" : "success",
            message:
              this.czlx !== "UPT"
                ? "报名未开始或已结束"
                : "报名已经结束，您只能查看信息，无法修改，请悉知",
            duration: 6000
          });
          return;
        }
      });
    },
    onTopClickLeft() {
      this.$router.go(-1);
    },
    onTopClickRight() {
      this.$router.go(-1);
    },
    mainData() {
      var busData = {
        XMID: this.xmid,
        isGetLxr: "1",
        bmLx: this.bmLx,
        dwid: this.ryInfo.DWID.VALUE,
        czlx: this.czlx,
        ryid1Param: this.ryInfo.RYID1.VALUE,
        ryid2Param: this.ryInfo.RYID2.VALUE,
        ryid3Param: this.ryInfo.RYID3.VALUE,
        checkBmrsLx: this.checkBmrsLx,
        isLoadDtInfo: "1",
        isLoadRyCount: "1"
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getXmData" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          this.isShow = false;
          alert(data.msg);
          return;
        }
        //alert(JSON.stringify(data));
        this.CSQRSHTML = data.content.CSQRSHTML;
        this.YesCsqrsVal = data.content.YesCsqrsVal;
        this.isShow = true;
        this.lxrDataList = data.content.lxrDataList;
        this.resultXmData = data.content.resultXmList[0].DATALIST[0];
        if (this.bmLx === "TEAM") {
          //如果团队报名 全部按照单打去填写
          this.SSLXTYPE = "S";
        } else {
          var SSLX = this.resultXmData.SSLX;
          this.SSLXTYPE = SSLX.substr(1, 2);
          // this.sslxXb = SSLX.substr(0, 1);
        }

        this.ryInfo = data.content.ryInfo;

        this.XBTYPE = SSLX.substr(0, 1);
        this.SSLX = SSLX;
        if (this.XBTYPE === "M" || this.XBTYPE === "G") {
          this.ryInfo.XB1.VALUE = "M";
          this.ryInfo.XB2.VALUE = "M";
          this.ryInfo.XB3.VALUE = "M";
        }

        if (this.XBTYPE === "W" || this.XBTYPE === "L") {
          this.ryInfo.XB1.VALUE = "W";
          this.ryInfo.XB2.VALUE = "W";
          this.ryInfo.XB3.VALUE = "W";
        }

        var arrayLdxm = this.ryInfo.LDXM.VALUE.split("&");
        var arrayLdtel = this.ryInfo.LDTEL.VALUE.split("&");
        this.ryInfo.LDXM.VALUE = arrayLdxm[0];
        this.ryInfo.LDTEL.VALUE = arrayLdtel[0];
        this.BSLXR = arrayLdxm[1];
        this.BSLXRTEL = arrayLdtel[1];
        if (this.bmLx === "GR" && this.ryInfo.LDTEL.VALUE.length === 0) {
          this.ISUPTDWMC = data.content.ISUPTDWMC;
          if (this.ISUPTDWMC !== "N" && this.czlx === "ADD") {
            this.ryInfo.DWQC.VALUE = "";
          }
        }

        //alert(JSON.stringify(this.lxrDataList));
      });
    },
    sumbitData() {
      // 身份证性别校验
      var genderCheckResult = this.checkIdCardGender();
      if (!genderCheckResult.isValid) {
        this.$notify({
          type: "danger",
          message: genderCheckResult.message,
          duration: 6000
        });
        return;
      }
      var ryInfo = this.ryInfo;
      if (ryInfo.DWQC.VALUE.length === 0) {
        this.$notify({
          type: "danger",
          message: "请填写队伍全称",
          duration: 6000
        });
        return;
      }
      // alert(JSON.stringify(ryInfo.DWJC));
      if (ryInfo.TEL1.VALUE.length === 0) {
        if (
          this.ssid ===
          "34714f4579684e48716e317451444d796a6d6c62657838425670654842337869"
        ) {
          ryInfo.TEL1.VALUE = "**";
        }
      }
      if (ryInfo.TEL2.VALUE.length === 0) {
        if (
          this.ssid ===
          "34714f4579684e48716e317451444d796a6d6c62657838425670654842337869"
        ) {
          ryInfo.TEL2.VALUE = "**";
        }
      }
      if (
        ryInfo.DWJC.VALUE.length === 0 ||
        ryInfo.DWQC.VALUE.length === 0 ||
        ryInfo.RYXM1.VALUE.length === 0 ||
        ryInfo.XB1.VALUE.length === 0 ||
        ryInfo.SFZH1.VALUE.length === 0 ||
        ryInfo.ZJLX1.VALUE.length === 0
      ) {
        this.$notify({
          type: "danger",
          message: "请检查队员1必填项",
          duration: 6000
        });
        return;
      } else {
        var keys = Object.keys(ryInfo);
        for (var i = 0; i < keys.length; i++) {
          var keyStr = keys[i];
          if (
            keyStr.indexOf("DWJC") === 0 ||
            keyStr.indexOf("DWQC") === 0 ||
            keyStr.indexOf("RYXM") === 0 ||
            keyStr.indexOf("XB") === 0 ||
            keyStr.indexOf("SFZH") === 0
          ) {
            continue;
          } else {
            if (keyStr.indexOf("1") > 0) {
              var jobj = ryInfo[keyStr];
              var ISSHOW = jobj.ISSHOW;
              var ISBT = jobj.ISBT;
              var VALUE = jobj.VALUE;
              if (ISSHOW === "1") {
                if (ISBT === "1") {
                  if (VALUE.length === 0) {
                    this.$notify({
                      type: "danger",
                      message: "请检查队员1必填项",
                      duration: 6000
                    });
                    return;
                  }
                }
              }
            }
          }
        }
      }
      if (this.ryInfo.ZJLX1.VALUE !== "SFZH") {
        if (this.ryInfo.SR1.VALUE.length === 0) {
          this.$notify({
            type: "danger",
            message: "请检查球员出生日期，不能为空哦",
            duration: 6000
          });
          return;
        }
      }

      if (this.SSLXTYPE === "D") {
        if (this.ryInfo.ZJLX2.VALUE !== "SFZH") {
          if (this.ryInfo.SR2.VALUE.length === 0) {
            this.$notify({
              type: "danger",
              message: "请检查球员出生日期，不能为空哦",
              duration: 6000
            });
            return;
          }
        }
        if (
          ryInfo.DWJC.VALUE.length === 0 ||
          ryInfo.DWQC.VALUE.length === 0 ||
          ryInfo.RYXM2.VALUE.length === 0 ||
          ryInfo.XB2.VALUE.length === 0 ||
          ryInfo.SFZH2.VALUE.length === 0 ||
          ryInfo.ZJLX2.VALUE.length === 0
        ) {
          this.$notify({
            type: "danger",
            message: "请检查队员2必填项",
            duration: 6000
          });
          return;
        } else {
          var keys = Object.keys(ryInfo);
          for (var i = 0; i < keys.length; i++) {
            var keyStr = keys[i];
            if (
              keyStr.indexOf("DWJC") === 0 ||
              keyStr.indexOf("DWQC") === 0 ||
              keyStr.indexOf("RYXM") === 0 ||
              keyStr.indexOf("XB") === 0 ||
              keyStr.indexOf("SFZH") === 0
            ) {
              continue;
            } else {
              if (keyStr.indexOf("2") > 0) {
                var jobj = ryInfo[keyStr];
                var ISSHOW = jobj.ISSHOW;
                var ISBT = jobj.ISBT;
                var VALUE = jobj.VALUE;
                if (ISSHOW === "1") {
                  if (ISBT === "1") {
                    if (VALUE.length === 0) {
                      this.$notify({
                        type: "danger",
                        message: "请检查队员2必填项",
                        duration: 6000
                      });
                      return;
                    }
                  }
                }
              }
            }
          }
        }
      }
      if (ryInfo.DWQC.VALUE === "个人组") {
        Dialog.confirm({
          title: "信息提示",
          message:
            "您填写的队伍全称为默认[个人组]，如需修改请点击取消，在队伍全称位置进行修改。"
        })
          .then(() => {
            if (this.CSQRSHTML.length === 0) {
              this.sendServerBmInfo();
            } else {
              this.isCsqrsTabVisible = true;
            }
          })
          .catch(() => {
            return;
          });
      } else {
        if (this.CSQRSHTML.length === 0) {
          this.sendServerBmInfo();
        } else {
          this.isCsqrsTabVisible = true;
        }
      }
    },
    sendServerBmInfo() {
      if (this.singImgBase64.length > 0) {
        if (!this.isSign) {
          this.$notify({
            type: "danger",
            message: "请签署参赛确认书",
            duration: 6000
          });
          return;
        }
      }
      // 身份证性别校验
      var genderCheckResult = this.checkIdCardGender();
      if (!genderCheckResult.isValid) {
        this.$notify({
          type: "danger",
          message: genderCheckResult.message,
          duration: 6000
        });
        return;
      }
      //只有个人才 校验性别
      var ryInfo = this.ryInfo;
      var msg = "是否提交至服务端？";
      if (this.bmLx === "GR") {
        if (this.resultXmData.ISSF === "1" && this.czlx === "ADD") {
          if (this.resultXmData.SFJE - 0 === 0) {
            msg = "是否提交缴费？";
          } else {
            msg =
              "您的报名费为：" + this.resultXmData.SFJE + "元，是否提交缴费？";
          }
        }
      }
      Dialog.confirm({
        title: "请确认信息",
        message: msg
      })
        .then(() => {
          if (this.bmLx === "GR" && this.ryInfo.LDTEL.VALUE.length === 0) {
            this.ryInfo.DWJC.VALUE = this.ryInfo.DWQC.VALUE;
          }
          var methodName = "";
          var busData = {};
          if (this.bmLx === "GR") {
            busData = {
              XMID: this.xmid,
              ryInfo: ryInfo,
              czlx: this.czlx,
              CSQRSHTML: this.CSQRSHTML + this.singImgBase64,
              YHDDH: this.yhddh
            };
            methodName = "insertGrRyxx";
          } else if (this.bmLx === "TEAM") {
            busData = {
              ryInfo: ryInfo,
              czlx: this.czlx,
              XMID: this.xmid,
              CSQRSHTML: this.CSQRSHTML + this.singImgBase64,
              YHDDH: this.yhddh
            };
            methodName = "insertTeamRyxx";
          } else {
            this.$notify({
              type: "danger",
              message: "类型不符",
              duration: 6000
            });
            return;
          }
          var paramData = {
            headerData: {
              ssid: this.ssid,
              op: this.op, //反射名称
              methodName: methodName //对应的方法名
            },
            busData: busData //参数内容
          };
          this.utilPost.paramData = paramData;
          this.utilPost.sendPost().then(data => {
            if (data.msg.indexOf("已报过此项目") > -1) {
              Dialog.confirm({
                title: "您已经报名过该项目!",
                message: "请点击确认前往我的项目进行处理"
              }).then(() => {
                this.$router.push({
                  path: "/alreadyBmxx",
                  query: {
                    ssid: this.ssid
                  }
                });
                return;
              });
              return;
            }
            this.$notify({
              type: data.isSuccess ? "success" : "danger",
              message: data.msg,
              duration: 7000
            });
            if (data.isSuccess) {
              // alert(this.isTeamSelect);
              if (this.isTeamSelect === "1") {
                this.$router.go(-1);
                return;
              }
              var XMNM = data.content.XMNM;
              var XMID = data.content.XMID;
              var ISSF = data.content.ISSF;
              if (this.czlx !== "ADD") {
                this.$notify({
                  type: "success",
                  message: "修改成功",
                  duration: 3000
                });
                this.$router.push({
                  path: "/alreadyBmxx",
                  query: {
                    ssid: this.ssid,
                    requestXmnm: XMNM,
                    requestXmid: XMID,
                    czlx: "ADD"
                  }
                });
                return;
              }
              this.payJumpModal.XMNM = XMNM;
              this.payJumpModal.XMID = XMID;
              this.payJumpModal.ISSF = ISSF === undefined ? "0" : ISSF;
              this.confirmVisible = true;
              this.isCsqrsTabVisible = false;
              return;
              // if (ISSF === "1") {
              //   // Dialog.alert({
              //   //   title: "报名成功",
              //   //   message:
              //   //     "请您在3个小时内完成缴费，超时未交费系统将会清除您的报名信息，请悉知"
              //   // }).then(() => {
              //   //   this.$router.push({
              //   //     path: "/alreadyBmxx",
              //   //     query: {
              //   //       ssid: this.ssid,
              //   //       requestXmnm: XMNM,
              //   //       requestXmid: XMID,
              //   //       czlx: "ADD"
              //   //     }
              //   //   });
              //   // });
              // } else {
              //   this.$notify({
              //     type: "success",
              //     message: data.msg,
              //     duration: 6000
              //   });
              //   this.$router.push({
              //     path: "/alreadyBmxx",
              //     query: {
              //       ssid: this.ssid,
              //       requestXmnm: XMNM,
              //       requestXmid: XMID,
              //       czlx: "ADD"
              //     }
              //   });
              // }
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 验证大陆身份证号码格式
    isMainlandIdCard(idCard) {
      if (!idCard || idCard.length !== 18) {
        return false;
      }
      // 大陆身份证正则：18位数字，最后一位可能是X
      var pattern = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
      return pattern.test(idCard);
    },
    // 从身份证号中提取性别
    getGenderFromIdCard(idCard) {
      if (!this.isMainlandIdCard(idCard)) {
        return null;
      }
      // 第17位数字，奇数为男性，偶数为女性
      var genderCode = parseInt(idCard.charAt(16));
      return genderCode % 2 === 1 ? "M" : "W";
    },
    // 校验身份证性别与填写性别是否一致
    checkIdCardGender() {
      var ryInfo = this.ryInfo;
      var errors = [];

      // 判断赛事类型：S=单打，D=双打，T=3v3或团体
      var playerCount = 1; // 默认单打
      if (this.SSLXTYPE === "S" || this.SSLXTYPE === "T") {
        playerCount = 1;
      } else if (this.SSLXTYPE === "D") {
        playerCount = 2; // 双打
        if (this.SSLX === "GD" || this.SSLX === "LD" || this.SSLX === "BD") {
          playerCount = 3;
        }
      }

      // 校验每个队员
      for (var i = 1; i <= playerCount; i++) {
        var zjlxKey = "ZJLX" + i;
        var sfzhKey = "SFZH" + i;
        var xbKey = "XB" + i;
        var ryxmKey = "RYXM" + i;
        console.log("asghakjghj");
        // 获取证件类型、证件号、性别
        var zjlx = ryInfo[zjlxKey] ? ryInfo[zjlxKey].VALUE : "";
        var sfzh = ryInfo[sfzhKey] ? ryInfo[sfzhKey].VALUE : "";
        var xb = ryInfo[xbKey] ? ryInfo[xbKey].VALUE : "";
        var ryxm = ryInfo[ryxmKey] ? ryInfo[ryxmKey].VALUE : "";

        // 只有当证件类型是身份证(SFZH)且证件号不为空时才校验
        if (zjlx === "SFZH" && sfzh && sfzh.length > 0) {
          // 判断是否为大陆身份证
          if (this.isMainlandIdCard(sfzh)) {
            var idCardGender = this.getGenderFromIdCard(sfzh);

            // 比对性别
            if (idCardGender && xb && idCardGender !== xb) {
              var playerName = ryxm || "队员" + i;
              var genderText = xb === "M" ? "男" : xb === "W" ? "女" : "未知";
              var idCardGenderText = idCardGender === "M" ? "男" : "女";
              errors.push(
                playerName +
                  "的身份证性别为" +
                  idCardGenderText +
                  "，但填写的性别为" +
                  genderText +
                  "，请核对后重新填写"
              );
            }
          }
        } else {
          if (zjlx === "SFZH") {
            var playerName = ryxm || "队员" + i;
            errors.push(playerName + "证件号格式错误");
          }
        }
      }

      // 返回校验结果
      if (errors.length > 0) {
        return {
          isValid: false,
          message: errors.join("；")
        };
      }

      return {
        isValid: true,
        message: ""
      };
    },
    setBtnDis(isDis) {
      this.tjBtnDis = isDis;
      if (isDis) {
        this.tjBtnTxt = "图片上传中";
      } else {
        this.tjBtnTxt = "提交";
      }
    },
    openSignModelYes() {
      this.yesCsqrsVisible = true;
    },
    openSignModel() {
      document.documentElement.scrollTop = 0;
      this.signVisible = true;
    },
    confirm(img, imgBase64) {
      this.singImgBase64 = "<div>监护人或运动员签字：</div>";
      this.singImgBase64 +=
        '<div><img style="width: 166px;" src="' + imgBase64 + '"/></div>';
      this.singImgBase64 +=
        "<div>法定监护人或运动员联系方式：" + this.uis.TEL + "</div>";
      this.singImgBase64 +=
        "<div style='margin-top:6px'>签署日期：" +
        this.utilPost.formatDate(new Date(), "yyyy年MM月dd日") +
        "</div>";
      this.signVisible = false;
      this.isSign = true;
    },
    cancel() {
      this.signVisible = false;
      this.isSign = false;
    },
    handleContinue() {
      // 关闭弹窗
      this.confirmVisible = false;
      // 刷新当前页面
      this.$router.go(0);
    },
    handlePayment() {
      if (this.payJumpModal.ISSF === "1") {
        this.$router.push({
          path: "/alreadyBmxx",
          query: {
            ssid: this.ssid,
            requestXmnm: this.payJumpModal.XMNM,
            requestXmid: this.payJumpModal.XMID,
            czlx: "ADD"
          }
        });
      } else {
        this.$router.push({
          path: "/alreadyBmxx",
          query: {
            ssid: this.ssid,
            requestXmnm: this.payJumpModal.XMNM,
            requestXmid: this.payJumpModal.XMID,
            czlx: "ADD"
          }
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 🎨 整体容器 */
.add-ry-info-container {
  min-height: 100vh;
  background: linear-gradient(180deg, #f5f7fa 0%, #ffffff 100%);
}

/* 🎨 顶部导航栏 */
.custom-nav-bar {
}

.custom-nav-bar >>> .van-nav-bar__title {
  color: black;
  font-size: 16px;
}

.custom-nav-bar >>> .van-nav-bar__text,
.custom-nav-bar >>> .van-icon {
  color: black;
}

.home-icon-link {
  font-size: 20px;
  color: #fff;
}

.home-icon {
  font-size: 22px;
}

.home-icon-link:active .home-icon {
  transform: scale(0.9);
}

/* 🎨 内容区域 */
.content-wrapper {
  background: #fff;
  margin: 10px;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(24, 95, 155, 0.15);
  overflow: hidden;
}

/* 🎨 赛事标题卡片 */
.event-title-card {
  text-align: center;
  padding: 3px 15px;
  font-size: 16px;
  font-weight: 700;
  color: #2c3e50;
  background: linear-gradient(
    135deg,
    rgba(24, 95, 155, 0.08) 0%,
    rgba(34, 115, 175, 0.08) 100%
  );
  border-bottom: 2px solid rgb(24, 95, 155);
  position: relative;
}

/* 🎨 项目单元格 */
.project-cell {
  background: #f8f9fa;
  border-left: 4px solid rgb(24, 95, 155);
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
  width: 95%;
  border-radius: 8px;
  margin-right: 12px;
}

.project-cell >>> .van-cell__title {
  color: rgb(24, 95, 155);
  font-weight: 600;
}

.project-cell >>> .van-cell__value {
  color: #2c3e50;
  font-weight: 500;
}

/* 🎨 信息横幅 */
.info-banner {
  background: linear-gradient(
    135deg,
    rgba(24, 95, 155, 0.1) 0%,
    rgba(34, 115, 175, 0.1) 100%
  );
  padding: 15px 0;
}

/* 🎨 队伍信息卡片 */
.team-info-card {
  background: #fff;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(24, 95, 155, 0.15);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1rem;
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
}

.header-icon {
  font-size: 1.25rem;
  color: #fff;
}

.header-title {
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.info-text-row {
  display: flex;
  align-items: center;
  padding: 0.875rem 1rem;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
}

.info-label {
  flex-shrink: 0;
  color: #6b7280;
  font-weight: 500;
  font-size: 0.875rem;
}

.info-value {
  flex: 1;
  color: #1f2937;
  font-weight: 600;
  font-size: 0.9375rem;
  word-break: break-all;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-left: 15px;
  margin-top: 2px;
  text-align: right;
}

.team-info-card .custom-field {
  border-bottom: 1px solid #f0f0f0;
}

.info-banner-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-banner-left {
  float: left;
  font-size: 14px;
}

.info-label {
  display: flex;
  align-items: center;
  color: rgb(24, 95, 155);
  font-weight: 500;
}

.comment-icon {
  margin-right: 6px;
  font-size: 16px;
}

.info-banner-right {
  float: right;
  font-size: 14px;
}

.required-label {
  color: #666;
  font-weight: 500;
}

.required-star {
  color: #ff4444;
  font-weight: 700;
  font-size: 16px;
}

/* 🎨 自定义输入框 */
.custom-field {
  border-bottom: 1px solid #f0f0f0;
}

.custom-field:hover {
  background: #fafafa;
}

.custom-field >>> .van-field__label {
  color: #666;
  font-weight: 500;
}

.custom-field >>> .van-field__control {
  color: #2c3e50;
}

.custom-field >>> .van-field__control:disabled {
  color: #999;
  background: #f5f5f5;
}

/* 🎨 选择队伍按钮 */
.select-team-btn {
  width: 86px;
  background: linear-gradient(
    135deg,
    rgb(24, 95, 155) 0%,
    rgb(34, 115, 175) 100%
  );
  border: none;
  border-radius: 6px;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(24, 95, 155, 0.3);
}

.select-team-btn:active {
  transform: scale(0.95);
  box-shadow: 0 1px 4px rgba(24, 95, 155, 0.3);
}

/* 🎨 报名费单元格 */
.fee-cell {
  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
  border-left: 4px solid #ff9800;
  margin: 10px;
  border-radius: 8px;
}

.fee-cell >>> .van-cell__title {
  color: #f57c00;
  font-weight: 600;
}

.fee-cell >>> .van-cell__value {
  color: #e65100;
  font-weight: 700;
  font-size: 16px;
}

/* 🎨 会员优惠单元格 */
.member-discount-cell {
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  border-left: 4px solid #4caf50;
  margin: 10px;
  border-radius: 8px;
}

.member-discount-cell >>> .van-cell__title {
  color: #388e3c;
  font-weight: 600;
}

.member-discount-cell >>> .van-cell__value {
  color: #2e7d32;
  font-weight: 700;
}

/* 🎨 底部操作栏 */
.custom-tabbar {
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.1);
}

.custom-goods-action {
  padding: 8px;
  background: #fff;
}

.view-confirm-btn {
  margin-right: 15px;
  background: linear-gradient(
    135deg,
    rgb(34, 115, 175) 0%,
    rgb(44, 135, 195) 100%
  );
  border: none;
  border-radius: 8px;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(34, 115, 175, 0.3);
}

.submit-btn {
  background: linear-gradient(
    135deg,
    rgb(24, 95, 155) 0%,
    rgb(34, 115, 175) 100%
  );
  border: none;
  border-radius: 8px;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(24, 95, 155, 0.3);
}

.submit-btn:disabled {
  background: #ccc;
  box-shadow: none;
}

.bottom-spacer {
  height: 150px;
  width: 100%;
}

/* 🎨 参赛确认书弹窗 */
.confirm-sheet >>> .van-action-sheet__header {
  background: linear-gradient(
    135deg,
    rgb(24, 95, 155) 0%,
    rgb(34, 115, 175) 100%
  );
  color: #fff;
  font-weight: 600;
}

.confirm-content {
  padding: 15px;
  padding-bottom: 80px;
  max-height: 70vh;
  overflow-y: auto;
}

.confirm-html {
  line-height: 1.8;
  color: #2c3e50;
  font-size: 14px;
}

.confirm-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.1);
  padding: 8px;
}

.cancel-btn {
  background: linear-gradient(135deg, #ef5350 0%, #e53935 100%);
  border: none;
  border-radius: 8px;
  font-weight: 600;
}

.sign-btn {
  background: linear-gradient(
    135deg,
    rgb(34, 115, 175) 0%,
    rgb(44, 135, 195) 100%
  );
  border: none;
  border-radius: 8px;
  font-weight: 600;
  margin-left: 15px;
}

.confirm-register-btn {
  background: linear-gradient(135deg, #66bb6a 0%, #43a047 100%);
  border: none;
  border-radius: 8px;
  font-weight: 600;
  margin-left: 15px;
}

/* 🎨 查看确认书弹窗 */
.view-confirm-sheet >>> .van-action-sheet__header {
  background: linear-gradient(
    135deg,
    rgb(34, 115, 175) 0%,
    rgb(44, 135, 195) 100%
  );
  color: #fff;
  font-weight: 600;
}

.view-confirm-content {
  padding: 15px;
  padding-bottom: 80px;
  max-height: 70vh;
  overflow-y: auto;
}

.view-confirm-html {
  line-height: 1.8;
  color: #2c3e50;
  font-size: 14px;
}

/* 🎨 选择队伍弹窗 */
.select-team-sheet >>> .van-action-sheet__header {
  background: linear-gradient(
    135deg,
    rgb(24, 95, 155) 0%,
    rgb(34, 115, 175) 100%
  );
  color: #fff;
  font-weight: 600;
}

.select-team-sheet-jg >>> .van-action-sheet__header {
  background: linear-gradient(135deg, #ff7d00 0%, #ff9a00 100%);
  color: #fff;
  font-weight: 600;
}

.select-team-content {
  max-height: 70vh;
  overflow-y: auto;
}

.select-team-notice {
  padding: 15px;
  color: #ff4444;
  font-size: 13px;
  background: #fff3f3;
  border-left: 4px solid #ff4444;
  margin: 10px 15px;
  border-radius: 4px;
  line-height: 1.6;
}

.search-field {
  margin: 10px 15px;
  border-radius: 8px;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
}

.search-btn {
  width: 80px;
  background: linear-gradient(
    135deg,
    rgb(24, 95, 155) 0%,
    rgb(34, 115, 175) 100%
  );
  border: none;
  border-radius: 6px;
  font-weight: 500;
}

.team-item {
  border-bottom: 1px solid #f0f0f0;
}

.team-item:hover {
  background: #f8f9fa;
}

.team-item:active {
  background: rgba(24, 95, 155, 0.1);
}

.select-team-spacer {
  width: 100%;
  height: 200px;
}

/* 🎨 响应式设计 */
@media (max-width: 375px) {
  .event-title-card {
    font-size: 15px;
    padding: 3px 12px;
  }

  .info-banner-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .info-banner-left,
  .info-banner-right {
    float: none;
  }
}

/* 🎨 滚动条美化 */
.confirm-content::-webkit-scrollbar,
.view-confirm-content::-webkit-scrollbar,
.select-team-content::-webkit-scrollbar {
  width: 6px;
}

.confirm-content::-webkit-scrollbar-thumb,
.view-confirm-content::-webkit-scrollbar-thumb,
.select-team-content::-webkit-scrollbar-thumb {
  background: linear-gradient(
    135deg,
    rgb(24, 95, 155) 0%,
    rgb(34, 115, 175) 100%
  );
  border-radius: 3px;
}

.confirm-content::-webkit-scrollbar-track,
.view-confirm-content::-webkit-scrollbar-track,
.select-team-content::-webkit-scrollbar-track {
  background: #f5f5f5;
}
/deep/.van-cell {
  width: auto;
}
.searchDwInfoDiv .van-cell {
  padding-left: 8px !important;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  padding-right: 0px !important;
}
/deep/ .custom-goods-action {
  padding: 0px !important;
}
/deep/ .van-tabbar {
  height: 46px;
}

/* ==================== 支付操作弹出框样式 ==================== */
.payment-action-content {
  padding: 1rem;
}

/* 成功提示 */
.success-notice {
  display: flex;
  align-items: flex-start;
  padding: 1rem;
  margin-bottom: 1.25rem;
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border-left: 4px solid #10b981;
  border-radius: 0.75rem;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.15);
}

.success-icon {
  font-size: 1.5rem;
  color: #10b981;
  margin-right: 0.75rem;
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.notice-text {
  flex: 1;
  min-width: 0;
}

.notice-title {
  font-size: 1rem;
  font-weight: 700;
  color: #065f46;
  margin-bottom: 0.375rem;
  line-height: 1.4;
}

.notice-desc {
  font-size: 0.8125rem;
  color: #047857;
  line-height: 1.5;
}

.notice-warning {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.8125rem;
  color: #dc2626;
  line-height: 1.5;
  margin-top: 0.5rem;
  padding: 0.5rem;
  background: rgba(220, 38, 38, 0.08);
  border-radius: 0.375rem;
  font-weight: 600;
}

.warning-icon {
  font-size: 1rem;
  color: #dc2626;
  flex-shrink: 0;
}

/* ==================== 全新按钮设计 ==================== */
.payment-buttons-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}

.modern-btn {
  flex: 1;
  border: none;
  outline: none;
  padding: 0;
  cursor: pointer;
  border-radius: 0.75rem;
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;
}

.btn-content {
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem 1.5rem;
  position: relative;
  z-index: 1;
}

.btn-icon {
  font-size: 1.375rem;
}

.btn-text {
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.3px;
}

/* 立即支付按钮 */
.payment-btn {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  box-shadow: 0 4px 15px rgba(220, 38, 38, 0.4);
}

/* 稍后支付按钮 */
.later-btn {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  box-shadow: 0 4px 15px rgba(24, 95, 155, 0.4);
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-4px);
  }
}

/* 移除旧样式 */
.action-buttons-row,
/* 移除旧样式 */
.action-buttons-row,
.compact-button,
.payment-compact-btn,
.continue-compact-btn,
.icon-3d-wrapper,
.icon-bg-circle,
.payment-icon-wrapper,
.continue-icon-wrapper {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ReportXm/AddRyInfo.vue